import { render } from "./App.vue?vue&type=template&id=3209b7f8&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3209b7f8&lang=scss"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__